import { supabase } from './supabase'
import { ROLES, hasRole, isAdmin, isAdminOrAvaliador, type Role } from './roles'

export async function getUserRolesFromToken(): Promise<string[]> {
  const { data: { session } } = await supabase.auth.getSession()
  if (!session?.user) return []

  const roles = session.user.app_metadata?.roles
  return Array.isArray(roles) ? roles : []
}

export async function hasRoleFromToken(role: Role): Promise<boolean> {
  return hasRole(await getUserRolesFromToken(), role)
}

export async function isAdminFromToken(): Promise<boolean> {
  return isAdmin(await getUserRolesFromToken())
}

export async function isAvaliadorFromToken(): Promise<boolean> {
  return hasRoleFromToken(ROLES.AVALIADOR)
}

export async function hasAdminOrAvaliadorAccessFromToken(): Promise<boolean> {
  return isAdminOrAvaliador(await getUserRolesFromToken())
}
